const myTransactions = {
  selectDateRage:'Выберите диапазон дат',
  selectTransactionType:'Выберите тип транзакции',
  selectApplication:'Выберите приложение',
  export:'Экспорт',
  myTransactions:'Мои транзакции',
  showing:'Показано',
  transactionsOf:'транзакции из',
  noTransactionsFound:'Транзакции не найдены',
};

export default myTransactions;
